/* istanbul ignore next */
export enum GeoMessageSenderId {
    Sport = "Sport",
    Casino = "Casino"
}